import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AssabilServicesMenuComponent } from './assabil-services-menu/assabil-services-menu.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AssetListMobileComponent } from './components-mobile/asset-list-mobile/asset-list-mobile.component';
import { AssetListComponent } from './components/asset-list/asset-list.component';
import { AssetWidgetComponent } from './components/asset-widget/asset-widget.component';
import { AssetOrderListComponent } from './components/asset-order-list/asset-order-list.component';
import { AssetTransferListComponent } from './components/asset-transfer-list/asset-transfer-list.component';
import { AssetTransferListMobileComponent } from './components-mobile/asset-transfer-list-mobile/asset-transfer-list-mobile.component';
import { AssetTransferWidgetMobileComponent } from './components-mobile/asset-transfer-widget-mobile/asset-transfer-widget-mobile.component';
import { AssetOrderListMobileComponent } from './components-mobile/asset-order-list-mobile/asset-order-list-mobile.component';
import { AssetOrderWidgetMobileComponent } from './components-mobile/asset-order-widget-mobile/asset-order-widget-mobile.component';
import { AssetOrderWidgetComponent } from './components/asset-order-widget/asset-order-widget.component';
import { AssetCallListComponent } from './components/asset-call-list/asset-call-list.component';
import { AssetInventoryListComponent } from './components/asset-inventory-list/asset-inventory-list.component';
import { AssetInventoryWidgetMobileComponent } from './components-mobile/asset-inventory-widget-mobile/asset-inventory-widget-mobile.component';
import { AssetInventoryWidgetComponent } from './components/asset-inventory-widget/asset-inventory-widget.component';
import { TicketListComponent } from './components/ticket-list/ticket-list.component';
import { TicketStatusLovComponent } from './components/ticket-status-lov/ticket-status-lov.component';
import { AssetLovComponent } from './components/asset-lov/asset-lov.component';
import { AssetProductCategoryListComponent } from './components/asset-product-category-list/asset-product-category-list.component';
import { AssetProductCategoryLovComponent } from './components/asset-product-category-lov/asset-product-category-lov.component';
import { AssetProductListComponent } from './components/asset-product-list/asset-product-list.component';
import { AssetProductLov } from './components/asset-product-lov/asset-product-lov.component';
import { AssetPipe } from './pipes/asset-pipe';
import { AssetDashboardComponent } from './components/asset-dashboard/asset-dashboard.component';
import { GeoAreaKpisWidgetComponent } from './components/geo-area-kpis-widget/geo-area-kpis-widget.component';
import { AssabilServicesRoutingModule } from './assabil-services-routing.module';
import { AssabilAdminModule } from '../assabil-admin/assabil-admin.module';
import { ToolsModule } from '../tools/tools.module';
import { AssetTransferWidgetComponent } from './components/asset-transfer-widget/asset-transfer-widget.component';
import { AssetTransferPipe } from './pipes/asset-transfer-pipe';
import { ColorPickerModule } from 'ngx-color-picker';
import { AssetAssignmentListComponent } from './components/asset-assignment-list/asset-assignment-list.component';
import { AssetAssignmentWidgetComponent } from './components/asset-assignment-widget/asset-assignment-widget.component';
import { AssetAssignmentPipe } from './pipes/asset-assignment-pipe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AssetBarcodeComponent } from './components-mobile/asset-barcode/asset-barcode.component';
import { AssetAssignmentWidgetMobileComponent } from './components-mobile/asset-assignment-widget-mobile/asset-assignment-widget-mobile.component';
import { AssetShipmentListMobileComponent } from './components-mobile/asset-shipment-list-mobile/asset-shipment-list-mobile.component';
import { AssetShipmentListComponent } from './components/asset-shipment-list/asset-shipment-list.component';
import { AssetShipmentWidgetComponent } from './components/asset-shipment-widget/asset-shipment-widget.component';
import { AssetShipmentPipe } from './pipes/asset-shipment-pipe';
import { AssetShipmentWidgetMobileComponent } from './components-mobile/asset-shipment-widget-mobile/asset-shipment-widget-mobile.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TicketWidgetComponent } from './components/ticket-widget/ticket-widget.component';
import { TicketTypeLovComponent } from './components/ticket-type-lov/ticket-type-lov.component';
import { TicketServiceListComponent } from './components/ticket-batch-list/ticket-batch-list.component';
import { TicketServiceWidgetComponent } from './components/ticket-batch-widget/ticket-batch-widget.component';
import { TicketPipe } from './pipes/ticket-pipe';
import { TicketBatchTicketWidgetComponent } from './components/ticket-batch-ticket-widget/ticket-batch-ticket-widget.component';
import { TicketXtrnListComponent } from './components/ticket-xtrn-list/ticket-xtrn-list.component';
import { TicketBatchTicketPipe } from './pipes/ticket-batch-ticket-pipe';

@NgModule({
  declarations: [
    AssabilServicesMenuComponent,
    AssetListMobileComponent,
    AssetListComponent,
    AssetWidgetComponent,
    AssetOrderListComponent,
    AssetTransferListComponent,
    AssetAssignmentListComponent,
    AssetAssignmentWidgetComponent,
    AssetTransferListMobileComponent,
    AssetTransferWidgetMobileComponent,
    AssetOrderListMobileComponent,
    AssetOrderWidgetMobileComponent,
    AssetOrderWidgetComponent,
    AssetCallListComponent,
    AssetInventoryListComponent,
    AssetInventoryWidgetMobileComponent,
    AssetInventoryWidgetComponent,
    TicketListComponent,
    TicketWidgetComponent,
    TicketXtrnListComponent,
    TicketStatusLovComponent,
    TicketTypeLovComponent,
    AssetLovComponent,
    AssetProductCategoryListComponent,
    AssetProductCategoryLovComponent,
    AssetProductListComponent,
    AssetProductLov,
    AssetPipe,
    TicketPipe,
    TicketBatchTicketPipe,
    AssetDashboardComponent,
    GeoAreaKpisWidgetComponent,
    AssetTransferWidgetComponent,
    AssetTransferPipe,
    AssetAssignmentPipe,
    AssetShipmentPipe,
    AssetBarcodeComponent,
    AssetAssignmentWidgetMobileComponent,
    AssetShipmentListMobileComponent,
    AssetShipmentListComponent,
    AssetShipmentWidgetComponent,
    AssetShipmentWidgetMobileComponent,
    TicketServiceListComponent,
    TicketServiceWidgetComponent,
    TicketBatchTicketWidgetComponent
 ],
  imports: [
    CommonModule,
    ToolsModule,
    ImageCropperModule,
    AssabilAdminModule,
    AssabilServicesRoutingModule,
    NgxDatatableModule,
    ColorPickerModule,
    PdfViewerModule,
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    AssabilServicesMenuComponent,
  ],
  providers: [
    DatePipe,
    AssetPipe,
    AssetPipe
  ],
  entryComponents:[
    AssetProductLov,
    AssetProductCategoryLovComponent,
    AssetLovComponent,
    TicketTypeLovComponent,
    TicketStatusLovComponent,
    TicketBatchTicketWidgetComponent
  ]
})
export class AssabilServicesModule { }
